import React, { useState, useCallback, useEffect } from "react";
import * as S from "./ModifySearchHeader.styles";
import dateformat from "dateformat";
import { useSelector, useDispatch, useStore } from "react-redux";
import Calendar from "./../../../../components/calendar/calendar";
import TimeDropdown from "../../../../../stories/components/cars/homepage/TimeDropdown/TimeDropdownUI";
import AutoSuggest from "../../../../components/autosuggest/autosuggest";
import {
  tripTypeSelector,
  sourceSelector,
  destinationSelector,
  startDateSelector,
  endDateSelector,
  hrPackageSelector,
  previousSourceSelector,
  previousDestinationSelector,
  multicityStopOversSelector,
  cabsConfigDataSelector,
  showRTRevampSelector,
  rtRevampSelector,
  rtRevampListingRTSelector,
  rtRevampToastTimeSelector
} from "../../../../common/redux/selector";
import {
  dynamicPersuasionSelector,
  endTimeSelector,
  startTimeSelector,
  loaderSelector,
  vehicledataSelector,
  commonSelector
} from "../../redux/selector";
import { fetchHourlyRentalDetails, fetchResults } from "../../redux/thunks";
import useOutsideClick from "../../../../hooks/useOutsideClick";
import HomeAutoSuggest from "../../../../../stories/components/cars/homepage/AutoSuggest/AutosuggestCard";
import { BLANK_VALUE, HR, SEO, tripAttr, tripAttributes, UNTILL_TEXT } from "../../../../config/constants";
import InfoBarUI from "../../../../../stories/components/cars/ResultsPage/InfoBar/InfoBarUI";
import useNavigate from "../../../../hooks/useNavigate";
import { convert24To12Format, replaceSRPUrlState, recentSearchStore } from "../../../../config/utils";
import ToolTipUI from "../../../../../stories/core-components/ToolTip/ToolTipUI";
import Popup from "../../../../../stories/core-components/PopupUI/PopupUI";
import { CTA_TYPE, getActionNameForOmniture, getTripTypeForOmniture, pushOmniEvents } from "../../../../../shared/utils/omni-utils";
import { gcTripCategoryScreen, get24HoursTime, getCtaProperty, getRouteDetails, getTripDays, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { dateTypeFormat, LOCAL_RENTAL, ROUND_TRIP, RouteCountry, timeTypeFormat, CABS_LISTING_ROUTE, MODIFY_SEARCH_HEADER, SEARCH, PICKUP_TIME_UPDATE, RETURN_TIME_UPDATE, PICKUP_DATE_CALANDER, PICKUP_TIME_CALANDER, RETURN_DATE_CALANDER, RETURN_TIME_CALANDER, MOB_CABS_LISTING, DROP_ERROR, PICKUP_ERROR, ADDRESS_SWAP, ADD_STOP, CLICKED, LISTINGPAGE } from "../../../../../shared/utils/util-constants";
import MuliticityPopup from "../MulitictyPopup/MuliticityPopup";
import { UPDATE_MULTICITY_STOPOVERS } from "../../redux/action-types";
import { isSeoMulticitySelector } from "../../../SeoPage/redux/selector";
import { UPDATE_DESTINATION, UPDATE_PREVIOUS_DESTINATION, UPDATE_PREVIOUS_SOURCE, UPDATE_SOURCE } from "../../../../common/redux/action-types";
export interface ISearchHeader {
  isSeo?: boolean;
  defaultShowWidget?: string;
  src?: string;
  dest?: string;
  charDham?: boolean;
}
let rtToastShown = false;
const Auto = ({ autosuggestRef, props, inputRef, label, type, setInitialPage, onShowInitialPage, handleKeyBoard }) => {
  const dispatch = useDispatch();
  const source = useSelector(sourceSelector);
  const destination = useSelector(destinationSelector);
  const prevSource = useSelector(previousSourceSelector);
  const prevDestination = useSelector(previousDestinationSelector);
  return (
    <S.WidgetType
      width={type === "rt" ? "18rem" : "24rem"}
      ref={autosuggestRef}
    >
      <S.TripTypeTxt>{label === "source" ? "FROM" : "TO"}</S.TripTypeTxt>
      <S.OutStandingWarpper width={type === "rt" ? "17rem" : "23rem"}>
        <S.OutStandingInputInner
          {...props}
          width={type === "rt" ? "14rem" : "21.1rem"}
          autoFocus={!props?.value || onShowInitialPage}
          onKeyDown={handleKeyBoard}
          onClick={() => {
            setInitialPage(true)
            const key = label === "source" ? "previousSource" : "previousDestination"
            dispatch({
              type: label === "source" ? UPDATE_PREVIOUS_SOURCE : UPDATE_PREVIOUS_DESTINATION,
              [key]: label === "source" ? source : destination,
            })
            dispatch({
              type: label === "source" ? UPDATE_SOURCE : UPDATE_DESTINATION,
              [label]: {},
            });

            if ((label === "source" && !destination?.name) || label === "destination" && !source?.name) {
              const key = label === "source" ? "destination" : "source"
              dispatch({
                type: label === "source" ? UPDATE_DESTINATION : UPDATE_SOURCE,
                [key]: label === "source" ? prevDestination : prevSource
              });
            }
            setTimeout(() => {
              if (inputRef.current) {
                inputRef.current.focus();
              }
            }, 0);
          }}
          ref={inputRef}
        ></S.OutStandingInputInner>
      </S.OutStandingWarpper>
      {!props?.value && <S.ErrorWrapper><ToolTipUI top={"1rem"} data={`Please Enter ${label === "source" ? "Pickup" : "Drop"} Location`} /></S.ErrorWrapper>}
    </S.WidgetType>
  );
};

const ModifySearchHeaderUI: React.FC<ISearchHeader> = ({ isSeo = false, defaultShowWidget = "", src, dest, charDham }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const [showWidget, setWidget] = useState(defaultShowWidget);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isUpdateSearch, setIsUpdateSearch] = useState(false)
  const [tripTypeChange, setTripTypeChange] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [openMulticityPopup, setOpenMulticityPopup] = useState(false);
  const [isMultiStopsExist, setIsMultiStopsExist] = useState(false);
  const [showFullWidget, setFullWidget] = useState(false);
  const startDate = useSelector(startDateSelector);
  const vehicle_data = useSelector(vehicledataSelector);
  const { date, time } = startDate;
  const endDate = useSelector(endDateSelector);
  const { date: eDate, time: eTime } = endDate;
  const source = useSelector(sourceSelector);
  const desc = useSelector(destinationSelector);
  const triptype = useSelector(tripTypeSelector);
  const hrSelectedPackageId : string = useSelector(hrPackageSelector)
  const commonData = useSelector(commonSelector);
  const modifyWidgetRef = React.createRef();
  const { rf = "", name = "" } = triptype;
  const dynamicPersuasion = useSelector(dynamicPersuasionSelector);
  const endTime = useSelector(endTimeSelector);
  const startTime = useSelector(startTimeSelector);
  const stopOvers = useSelector(multicityStopOversSelector)
  const loader = useSelector(loaderSelector);
  const configData = useSelector(cabsConfigDataSelector)
  const isRTRevamp = useSelector(showRTRevampSelector);
  const rtRevampText = useSelector(rtRevampSelector);
  const rtText = useSelector(rtRevampListingRTSelector)
  const rtToastOpenTime = useSelector(rtRevampToastTimeSelector)
  const isSeoMulticity = useSelector(isSeoMulticitySelector);
  const et = !!(endTime && !tripTypeChange) && !isSeo ? convert24To12Format(new Date(endTime)) : eTime;
  const st = !!(startTime && !tripTypeChange) && !isSeo ? convert24To12Format(new Date(startTime))  : time;
  const [navigateTo] = useNavigate();
  const updateTripType = useCallback(
    (name, rf) => {
      const btnName : string = getTripTypeForOmniture(name)
      pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, btnName), CTA_TYPE.RADIO_BUTTON, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
      setWidget("");
      setTripTypeChange(true);
      dispatch({
        type: "UPDATE_TRIP_TYPE",
        tripType: { name, rf },
      });
      if (isSeo) {
        seoRedirection();
      } else {
        dispatch(fetchResults({}));
      }
    },
    [dispatch]
  );
  useOutsideClick(modifyWidgetRef, () => {
    setWidget("");
  });

  const handlePageShow = (event) => {
    if (event.persisted && isSeo) {
      dispatch({
        type: UPDATE_MULTICITY_STOPOVERS,
        stopOvers: []
      })
    }
  }

  useEffect(() => {
    window.addEventListener('pageshow', handlePageShow);

    if (stopOvers?.length && stopOvers[0]?.value?.name?.length) {
      setIsMultiStopsExist(true)
    }

    return () => {
      setIsMultiStopsExist(true)
      window.removeEventListener('pageshow', handlePageShow);
    }
  }, [])


  useEffect(() => {
    if (isSeo) {
      dispatch({
        type: UPDATE_MULTICITY_STOPOVERS,
        stopOvers: []
      })
    }
  }, [isSeo])
  
  
  useEffect(() => {
    if (loader) {
      setTripTypeChange(false);
    }
  }, [loader]);

  useEffect(()=>{
    if(triptype?.rf === "rt" && isRTRevamp && !rtToastShown){
      setWidget("returntime");
      setTimeout(() => {
        setWidget("")
        rtToastShown = true
      },rtToastOpenTime)
    }
  },[triptype.rf, isRTRevamp, rtToastOpenTime])
  const updateTime = useCallback(
    (time, isPickup) => {
      setWidget("");
      setTripTypeChange(true);
      pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, isPickup ? PICKUP_TIME_UPDATE : RETURN_TIME_UPDATE), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
      dispatch({
        type: isPickup ? "UPDATE_START_TIME" : "UPDATE_END_TIME",
        time,
      });
      seoRedirection();
    },
    [dispatch]
  );

  useEffect(() => {
    if (isUpdateSearch && !loader) {
      setIsUpdateSearch(false)
      const startTimeDetails  : string = `${dateformat(startDate?.date, 'yyyy-mm-dd')}T${get24HoursTime(startDate?.time)}`
      const endTimeDetails    : string = `${dateformat(endDate?.date, 'yyyy-mm-dd')}T${get24HoursTime(endDate?.time)}`

      const eventDetails = {
        cta: getCtaProperty(getActionNameForOmniture(gcTripCategoryScreen, SEARCH), CTA_TYPE.BUTTON, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE),
        search: {
          searchId: commonData?.dispatch_search_id || ''
        }, 
        booking: {
          tripType: commonData?.trip_type || name,
          routeCity: name === LOCAL_RENTAL ? getRouteDetails(commonData?.source_city ? commonData?.source_city : source?.name, '') : getRouteDetails(commonData?.source_city, commonData?.destination_city)?.length ? getRouteDetails(commonData?.source_city, commonData?.destination_city) : getRouteDetails(source?.name, desc?.name),
          routeState: name === LOCAL_RENTAL ? getRouteDetails(commonData?.source?.State ? commonData?.source?.State : source?.state, '') : getRouteDetails(commonData?.source?.State, commonData?.destination?.State)?.length ? getRouteDetails(commonData?.source?.State, commonData?.destination?.State) : getRouteDetails(source?.state, desc?.state),
          routeCountry: RouteCountry,
          departureDate: commonData?.start_time ? `${dateformat(commonData?.start_time, dateTypeFormat)}` : `${dateformat(startTimeDetails, dateTypeFormat)}`,
          departureTime: commonData?.start_time ? `${dateformat(commonData?.start_time, timeTypeFormat)}` : `${dateformat(startTimeDetails, timeTypeFormat)}`,
          cabsIsPrivateAvailable: vehicle_data?.length ? "yes" : "no",
          daysToTrip: commonData?.start_time ? getTripDays(new Date().toString(), commonData?.start_time) : getTripDays(new Date().toString(), startTimeDetails)
        }
      }

      if (name === ROUND_TRIP) {
        eventDetails.booking["returnDate"]  = commonData?.end_time ? `${dateformat(commonData?.end_time, dateTypeFormat)}` : `${dateformat(endTimeDetails, dateTypeFormat)}`
        eventDetails.booking["returnTime"]  = commonData?.end_time ? `${dateformat(commonData?.end_time, timeTypeFormat)}` : `${dateformat(endTimeDetails, timeTypeFormat)}`
        eventDetails.booking["duration"]    = commonData?.start_time && commonData?.end_time ? getTripDays(commonData?.start_time, commonData?.end_time) : getTripDays(startTimeDetails, endTimeDetails)
      }

      if (name === LOCAL_RENTAL) {
        eventDetails.booking["packageId"] = hrSelectedPackageId
      }
      
      pushOmniEvents({eventName: "cabsUpdateSearch", details: eventDetails})
    }
  }, [loader, isUpdated, commonData])

  useEffect(() => {
    const handleScroll = () => {
      const scrolledHeight = window.pageYOffset || document.documentElement.scrollTop;
      if (scrolledHeight >= 140 && charDham) {
        setFullWidget(true);
      } else {
        setFullWidget(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setFullWidget]);

  const seoRedirection = (label = '', item = { place_id: '' }) => {
    let tripTypeVal = ''
    if (triptype?.rf === 'hr') {
      tripTypeVal = 'rental'
    } else if (triptype?.rf === 'at') {
      tripTypeVal = 'airport'
    } else {
      tripTypeVal = 'outstation'
    }
    if (isSeo) {
      const isRental = triptype?.rf === HR;
      if (source?.name && (isRental || desc?.name)) {
        navigateTo("srp", true);
      } else if (!source?.name || !desc?.name) {
        if (label === "source" && item?.place_id && desc?.name) {
          navigateTo("srp", true);
        } else if (label === "destination" && item?.place_id && source?.name) {
          navigateTo("srp", true);
        } else {
          const loc = source?.name ? "Drop" : "Pickup";
          const title = `${loc} Location is Empty`;
          const content = `Please Enter Your ${loc} Location to proceed.`;
          pushCtaOmniEvents(`${MOB_CABS_LISTING}_seo_${tripTypeVal}_${loc === "Drop" ? DROP_ERROR : PICKUP_ERROR}`, CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
          setErrorMessage({ title, content });
        }
      }
    }
  };

  const onUpdateSearch = useCallback(() => {
    if (!source?.name) return
    if (!desc?.name && triptype?.rf !== 'hr') return
    setIsUpdateSearch(true)
    if (isSeo) {
      seoRedirection('', {place_id:''});
      return;
    } else {
      const hrDest = {
        city_name: BLANK_VALUE,
        name: BLANK_VALUE,
        place_id: BLANK_VALUE,
        state: BLANK_VALUE,
        lobCity: BLANK_VALUE,
        loc_type: BLANK_VALUE,
        locus: {}
      }
      const dest = triptype?.rf === 'hr' ? hrDest : desc;
      recentSearchStore({ source, destination: dest, startDate, endDate, triptype, package_id: hrSelectedPackageId });
      dispatch({
        type: "CLEAR_FILTER",
        filters: {},
      });
      dispatch(fetchResults({}));
      if (triptype?.rf === 'hr') {
        dispatch(fetchHourlyRentalDetails())
      }
      setIsUpdated(true);
    }
  }, [dispatch, startDate, endDate, triptype, source, desc, hrSelectedPackageId, isSeo]);

  useEffect(() => {
    if (isUpdated) {
      if(window?.location?.href?.includes('/review') || window?.location?.href?.includes('/results')) {
        replaceSRPUrlState(store);
      }
      setIsUpdated(false);
    }
  }, [vehicle_data]);

  const handleSwapClick = () => {
    pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, ADDRESS_SWAP), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
    dispatch({
      type: "UPDATE_SRC_AND_DESC"
    });
  }

  const onAddStopsClick = () => {
    if (!stopOvers?.length) {
      const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
      const newStop = {
        id : newStopOvers.length + 1,
        value: {}
      }
      newStopOvers.push(newStop)
      pushCtaOmniEvents(isSeo ? `${MOB_CABS_LISTING}_${SEO}_${ADD_STOP}_${newStopOvers.length + 1}_${CLICKED}` : `${MOB_CABS_LISTING}_${ADD_STOP}_${newStopOvers.length + 1}_${CLICKED}`, CTA_TYPE.BUTTON, LISTINGPAGE, CABS_LISTING_ROUTE)
      dispatch({
        type: UPDATE_MULTICITY_STOPOVERS,
        stopOvers: newStopOvers
      })
    }
    setTimeout(() => {
      pushCtaOmniEvents(isSeo ? `${MOB_CABS_LISTING}_${SEO}_${ADD_STOP}_${CLICKED}` : `${MOB_CABS_LISTING}_${ADD_STOP}_${CLICKED}`, CTA_TYPE.BUTTON, LISTINGPAGE, CABS_LISTING_ROUTE)
    }, 10)
    setOpenMulticityPopup(true);
  }

  const stopOversStr = useCallback(
    () => {
      let stopOversStrVal = "+ Add Stops"

      const filteredStops = stopOvers.filter(stop => stop?.value?.name)

      if (filteredStops?.length) {
        stopOversStrVal = filteredStops?.length > 1 ? `+ ${filteredStops?.length} Stops` : `+ ${filteredStops?.length} Stop`
      }

      return stopOversStrVal
    }, [stopOvers]
  )

  return (
    <>
      <S.ModifyHeader
        ref={modifyWidgetRef}
        isMulticity={configData?.multicity || stopOvers?.length || isSeo}
        isCharDham={charDham}
        padding={
          rf === "rt"
            ? "1.2rem 0 1.2rem 5.2rem"
            : "1.2rem 0 1.2rem 0"
        }
        id="stickyWidget"
        isSticky={showFullWidget}
      >
        <S.TripType>
          <S.TripTypeTxt>TRIP TYPE</S.TripTypeTxt>
          <S.OutStandingWarpper
            width={"23rem"}
            onClick={() => setWidget("showtriptype")}
          >
            <S.OutStandingInner>{tripAttr[name]?.name}</S.OutStandingInner>
            {(triptype?.rf !== "at" && rf !== "hr") ? (
              <S.ArrowDownIcon></S.ArrowDownIcon>
            ) : null}
          </S.OutStandingWarpper>
          {showWidget === "showtriptype" && (rf !== "at" && rf !== 'hr') ? (
            <S.TripTypeSelection top={charDham ? showFullWidget ? 8 : 23 : 15}>
              {tripAttributes.map(
                ({ name, sName, title, rf: tf, tripType }) => {
                  if (tf === "at" || tf === "hr") return null;
                  return (
                    <div onClick={() => updateTripType(tripType, tf)}>
                      <HomeAutoSuggest
                        title={`${name} ${sName}`}
                        subTitle={title}
                        IconNavigationCheck={
                          rf === tf ? "IconNavigationCheck" : ""
                        }
                      />
                    </div>
                  );
                }
              ) || null}
            </S.TripTypeSelection>
          ) : null}
        </S.TripType>

        <AutoSuggest
          widget={Auto}
          label={"source"}
          labelVal={"From"}
          title={source?.name || src}
          type={triptype?.rf}
          popularSearch={[]}
          top={charDham ? showFullWidget ? "8rem" : "23rem" : "15rem"}
          onSuggestUpdate={seoRedirection}
          invokedFor={gcTripCategoryScreen}
        />
        { triptype?.rf !== 'hr' && !charDham && !(triptype?.rf !== "at" && (configData?.multicity || stopOvers?.length || (isSeo && isSeoMulticity))) ? (
          <div style={{marginTop:20, paddingRight:10}} onClick={handleSwapClick}>
            <img src="https://gos3.ibcdn.com/Switch-1664882765.svg" className="appendTop10" style={{cursor:'pointer'}} alt="switch_icon"></img>
          </div>
        ) : null}
        {(triptype?.rf !== 'hr' && triptype?.rf !== "at" && (configData?.multicity || stopOvers?.length || (isSeo && isSeoMulticity) || charDham)) ? (
          <S.StopoversTextCont onClick={() => onAddStopsClick()}>
            <div className="btn-gradient-1">
              <p>new</p>
            </div>
            {stopOversStr()}
          </S.StopoversTextCont>
        ) : null}
        {triptype?.rf !== 'hr' ? (
          <AutoSuggest
            widget={Auto}
            label={"destination"}
            labelVal={"To"}
            title={desc?.name || dest}
            type={triptype?.rf}
            popularSearch={[]}
            top={charDham ? showFullWidget ? "8rem" : "23rem" : "15rem"}
            onSuggestUpdate={seoRedirection}
            invokedFor={gcTripCategoryScreen}
          />
        ) : null}
        <S.WidgetType
          width={"11rem"}
          marginRight={"1rem"}
        >
          <S.TripTypeTxt>PICKUP DATE</S.TripTypeTxt>
          <S.OutStandingWarpper
            width={"11rem"}
            onClick={() => {
              pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, PICKUP_DATE_CALANDER), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
              setWidget("pickupdate")
            }}
          >
            <S.OutStandingInner>
              {dateformat(date, "dd mmm' yy")}
            </S.OutStandingInner>
          </S.OutStandingWarpper>
          {showWidget === "pickupdate" ? (
            <Calendar
              toggleCalendar={setWidget}
              extraAction={seoRedirection}
              invokedFor={gcTripCategoryScreen}
              isMulticity={triptype?.rf !== 'hr' && triptype?.rf !== "at" && (configData?.multicity || stopOvers?.length || (isSeo && isSeoMulticity))}
              isPickUp
            />
          ) : null}
        </S.WidgetType>
        <S.WidgetType width={"11rem"}>
          {showWidget === "pickuptime" ? (
            <TimeDropdown date={date} time={time} updateTime={updateTime} pickupTime={time} pickupDate={date}/>
          ) : null}
          <S.TripTypeTxt>PICKUP TIME</S.TripTypeTxt>
          <S.OutStandingWarpper
            width={"10rem"}
            onClick={() => {
              pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, PICKUP_TIME_CALANDER), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
              setWidget("pickuptime")
            }}
          >
            <S.OutStandingInner>{st}</S.OutStandingInner>
          </S.OutStandingWarpper>
        </S.WidgetType>
        {rf === "rt" || (stopOvers?.length && stopOvers[0]?.value?.name?.length) ? (
          <>
            <S.WidgetType width={"11rem"} marginRight={"1rem"}>
              <S.TripTypeTxt>RETURN BY DATE</S.TripTypeTxt>
              <S.OutStandingWarpper
                width={"11rem"}
                onClick={() => {
                  pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, RETURN_DATE_CALANDER), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE)
                  setWidget("returndate")
                }}
              >
                <S.OutStandingInner>
                  {dateformat(eDate, "dd mmm' yy")}
                </S.OutStandingInner>
              </S.OutStandingWarpper>
              {showWidget === "returndate" ? (
                <Calendar
                  toggleCalendar={setWidget}
                  isPickUp={false}
                  invokedFor={gcTripCategoryScreen}
                  extraAction={seoRedirection}
                  isMulticity={triptype?.rf !== 'hr' && triptype?.rf !== "at" && (configData?.multicity || stopOvers?.length || (isSeo && isSeoMulticity))}
                />
              ) : null}
            </S.WidgetType>
            <S.WidgetType width={"11rem"}>
              {showWidget === "returntime" && !(isRTRevamp && triptype?.rf === "rt") ? (
                <TimeDropdown
                  date={eDate}
                  time={eTime}
                  updateTime={updateTime}
                  isPickup={false}
                  initialTime={date?.toDateString() === eDate?.toDateString() ? time : null}
                  pickupTime={time}
                  pickupDate={date}
                />
              ) : null}
              <S.TripTypeTxt>RETURN BY TIME</S.TripTypeTxt>
              {!(isRTRevamp && triptype?.rf === "rt") ?
                <S.OutStandingWarpper
                  width={"10rem"}
                  onClick={() => {
                    pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, RETURN_TIME_CALANDER), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE);
                    setWidget("returntime")
                  }}
                >
                  <S.OutStandingInner>{et}</S.OutStandingInner>
                </S.OutStandingWarpper> :
              <S.ReturnTimeContainer>
                <S.RTTimeWrapper
                  width={"15rem"}
                  onClick={() => {
                    pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, RETURN_TIME_CALANDER), CTA_TYPE.HYPER_LINK, MODIFY_SEARCH_HEADER, CABS_LISTING_ROUTE);
                    setWidget("returntime")
                  }}
                  onMouseEnter={() => {
                    {isRTRevamp && triptype?.rf === "rt" && setWidget("returntime")}
                  }}
                  onMouseLeave={() => {
                    {isRTRevamp && triptype?.rf === "rt" && setWidget("")}
                  }}
                >
                  <S.ColumnContainer>
                    <S.SmallText>{UNTILL_TEXT}</S.SmallText>
                    <S.BoldText>{rtText}</S.BoldText>
                  </S.ColumnContainer>
                </S.RTTimeWrapper>
                {showWidget === "returntime" &&<S.TooltipContainer>
                  <S.TooltipArrow/>
                  <S.TooltipText>{rtRevampText}</S.TooltipText>
                </S.TooltipContainer>}
              </S.ReturnTimeContainer>}
            </S.WidgetType>
          </>
        ) : null}
        <S.UpdateButton
          onClick={onUpdateSearch}
        >
          <S.updateButtonTxt>UPDATE SEARCH</S.updateButtonTxt>
        </S.UpdateButton>
      </S.ModifyHeader>
      {!isSeo && <InfoBarUI dynamicPersuasion={dynamicPersuasion} />}
      {errorMessage && <Popup title={errorMessage?.title} content={errorMessage?.content} onCloseClick={() => setErrorMessage(null)} size='medium' />}
      {openMulticityPopup ? (
        <MuliticityPopup onClosePopup={() => {
          setOpenMulticityPopup(false)
          if ((stopOvers?.length && stopOvers[0]?.value?.name?.length) || isMultiStopsExist) onUpdateSearch()
        }} isSeo={isSeo} />
      ) : null}
    </>
  );
};

export default React.memo(ModifySearchHeaderUI);
